import React from "react";
import styled from "styled-components";

const BaseVisibilityWrapper = styled.div<{ isVisible?: boolean }>`
  display: ${props => (props?.isVisible === true ? "block" : "none")};
`;

interface VisibilityWrapperProps {
  readonly isVisible?: boolean;
  readonly children: React.ReactNode;
  readonly className?: string;
  readonly fallback?: React.ReactNode | JSX.Element;
}

export function VisibilityWrapper({ isVisible = false, children, className, fallback }: VisibilityWrapperProps) {
  return (
    <>
      <BaseVisibilityWrapper className={className} isVisible={isVisible}>
        {children}
      </BaseVisibilityWrapper>
      <BaseVisibilityWrapper className={className} isVisible={!isVisible}>
        {fallback}
      </BaseVisibilityWrapper>
    </>
  );
}
